var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dashboardComponent,{key:_vm.$store.state.national.mode,tag:"component"})
}
var staticRenderFns = []

export { render, staticRenderFns }